
<div class="trip-detail-popup-right">
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons">  
</div>
<form [formGroup]="webpageForm"  class="admin-forms">
    <div class="accordion-class">
        <h5>Add Load</h5>
        <mat-divider></mat-divider>
    </div>
    <div class="input-fileds-container">
        <div class="group">
            <div class="row">
                <div class="col-md-6"></div>
            </div>
        </div>
        <mat-form-field>
            <mat-label>Title</mat-label>
            <input matInput formControlName="title" required>
            <mat-error>Please Enter Valid title</mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Notes</mat-label>
            <textarea matInput formControlName="notes" required></textarea>
            <mat-error>Please Enter Valid page</mat-error>
        </mat-form-field>
        
    </div>
    <button type="button" class="button buttonBlue">Add Page
    </button>
</form>

